import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const OrderTotalContent = styled.div`
  padding: 16px 0;
`;

export const TextContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-top: 1px solid ${({ theme })=> theme.colors.grey[2]};
  &:last-child {
    border-bottom: none;
  }
`;

export const SubTotalText = styled.p`
  ${({ theme }) => css(theme.typographys.small.regular)};
  color: ${({ theme }) => theme.colors.neutrals.b};
`;

export const ShippingText = styled.p`
  ${({ theme }) => css(theme.typographys.small.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};
`;

export const TotalPrice = styled.p`
  ${({ theme }) => css(theme.typographys.m.bold)};
  color: ${({ theme }) => theme.colors.neutrals.b};
`;





